import { render, staticRenderFns } from "./MobileAttributesTable.vue?vue&type=template&id=040d5941&scoped=true&"
import script from "./MobileAttributesTable.vue?vue&type=script&lang=js&"
export * from "./MobileAttributesTable.vue?vue&type=script&lang=js&"
import style0 from "./MobileAttributesTable.vue?vue&type=style&index=0&id=040d5941&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d5941",
  null
  
)

export default component.exports